import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createProject } from '../../api/apiProjects';
import toast from 'react-hot-toast';
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

export const useCreateProject = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: createProjectMutate,
        isPending,
    } = useMutation({
        mutationFn: createProject,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['projects'] });
            toast.success(data.message || 'Project created successfully');
            navigate('/projects');
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || 'Failed to create project');
        },
    });

    return {
        createProjectMutate,
        isPending,
    };
};